<app-lotti-animation path="/lottie/global-loading.json"
    [ngStyle]="{'width.px': size,'height.px': size}"></app-lotti-animation>